const routes = [
  {
    path: '/science-edu',
    name: 'science-edu',
    component: () => import('@/views/web-h5/ScienceEdu.vue'),
    meta: {
      title: '科普教育基地',
    },
  },
  {
    path: '/wenjuan',
    name: 'wenjuan',
    component: () => import('@/views/wenjuan/SurveyPage.vue'),
    meta: {
      title: '用户画像调查问卷',
      hideShare: true,
    },
  },
  {
    path: '/volproject-details',
    name: 'volproject-details',
    component: () => import('@/views/web-h5/VolunteerProject.vue'),
    meta: {
      title: '项目详情',
      hideShare: true,
    },
  },
];
export default routes;
